
export default {
  isInPrerender: !!window.navigator.userAgent.includes('HeadlessChrome'),
}




// WEBPACK FOOTER //
// ./src/prerender.js